import React from 'react';

//styles
import './About.scss'

import {motion} from "framer-motion";


//client
import {urlFor} from "../../client";
import {AppWrap, MotionWrap} from "../../wrapper";

//hooks
import useFetchSanity from "../../hooks/useFetchSanity";

const About = () => {

    const {state:abouts} = useFetchSanity('abouts');

    return (
        <>
            <h2 className="head-text"><span>Good Design</span><br/>means <span>Good Business</span>
            </h2>

            <div className="app__profiles">
                {abouts.map((about, index) => (
                    <motion.div
                        key={about.title + index}
                        whileInView={{opacity: 1}}
                        whileHover={{scale: 1.1}}
                        transition={{duration: 0.5, type: 'tween'}}
                        className="app__profile-item"
                    >
                        <img src={urlFor(about.imgUrl)} alt={about.title}/>
                        <h2 className="bold-text" style={{marginTop: 20}}>{about.title}</h2>
                        <p className="p-text" style={{marginTop: 10}}>{about.description}</p>

                    </motion.div>
                ))}
            </div>
        </>
    )
}
export default AppWrap(
    MotionWrap(About, 'app__about'),
    'about',
    "app__whitebg"
);